<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <keep-alive>
        <router-view  v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="router-fade" mode="out-in">
      <router-view  v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import BrowerLogger from 'alife-logger'

export default {
  name: 'App',

  computed: {
    ...mapState([
      'newMsgNumber'
    ])
  },

  created() {
    this.hasNewMsg()
    this.getPoints()
    this.getUserInfo()
    this.isVip()
    this.getCouponQuantity()
    this.getEcardQuantity()
    this.getappid()
    this.getRightsQuantity()
    this.getGardenSwitch()
    this.isNewUser()
    this.isGardenSigned()
  },

  mounted() {
    // BrowerLogger.singleton({
    //  pid: location.hostname === 'm.changyoyo.com' ? 'igqkhnclmx@14602e4d7426072' : 'igqkhnclmx@f25aa00edae4e86',
    //  appType: 'web',
    //  imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    //  sendResource: true,
    //  enableLinkTrace: true,
    //  behavior: true
    // })
  },

  methods: {
    ...mapActions([
      'hasNewMsg',
      'getPoints',
      'getUserInfo',
      'isVip',
      'getCouponQuantity',
      'getEcardQuantity',
      'getappid',
      'getRightsQuantity',
      'getGardenSwitch',
      'isNewUser',
      'isGardenSigned'
    ])
  }
}
</script>

<style lang="scss">
.router-fade-enter-active, .router-fade-leave-active {
  transition: opacity .1s;
}
.router-fade-enter, .router-fade-leave-active {
  opacity: 0;
}
</style>
